import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { eliminarNotificaciones } from "../services/notificaciones.service";

import { dangerNotification } from '../../../redux/slices/ui';

export const useClear = () => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const clearMutation = useMutation({
        mutationFn: eliminarNotificaciones,
        onSuccess: (notificaciones, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['notificaciones'], exact: false });
        },
        onError: (error, variables, context) => {
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        clearMutation,
    }
}